import clsx from "clsx";
import ReactSelect from "react-select";
import { Controller } from "react-hook-form";
import { FixedSizeList as List } from "react-window";

const customStyles = {
  control: (provided, state) => {
    let borderColor = "#d8d8d8";
    if (state.isFocused) borderColor = "#ed6842";
    if (!!state.selectProps["data-error"]) borderColor = "#dc3545";

    return {
      ...provided,
      minHeight: 44,
      borderWidth: 2,
      borderColor,
      borderRadius: 0,
      boxShadow: "none",
      "&:hover": { borderColor },
    };
  },
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: state.isFocused ? "#ed6842" : "#d8d8d8",
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 100,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#d8d8d8",
    borderRadius: 0,
  }),
  option: (provided, state) => {
    let backgroundColor = "#fff";
    if (state.isFocused) backgroundColor = "#eee";
    if (state.isSelected) backgroundColor = "#ed6842";

    return {
      ...provided,
      color: state.isSelected ? "#fff" : "#444",
      backgroundColor,
      "&:active": { backgroundColor },
    };
  },
};

const Select = ({
  label,
  info,
  name,
  control,
  defaultValue,
  options = [],
  placeholder,
  validation,
  error,
  isLoading = false,
  ...props
}) => {
  return (
    <div
      className={clsx(
        "form-group",
        !!validation?.required && "required",
        error && "invalid"
      )}
    >
      <label htmlFor={`${name}_select`} className="form-label">
        {label}
        {info && (
          <span className="form-info-icon" title={info}>
            i
          </span>
        )}
      </label>

      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        rules={validation}
        render={({ field }) => (
          <ReactSelect
            {...field}
            {...props}
            id={`${name}_select`}
            instanceId={`${name}_select`}
            options={options}
            value={options.find((option) => option.value === field.value)}
            styles={customStyles}
            placeholder={isLoading ? "Loading..." : placeholder}
            onChange={(value) => field.onChange(value?.value)}
            onBlur={(e) => e.preventDefault()}
            data-error={error}
            isLoading={isLoading}
          />
        )}
      />

      {error && <div className="invalid-feedback mt-1">{error.message}</div>}
    </div>
  );
};

export default Select;

export const VirtualisedMenuList = ({
  options,
  children,
  maxHeight,
  getValue,
}) => {
  const height = 40; // Height of each option
  const selectedValue = getValue()[0]; // Currently selected value
  const initialIndex = options.findIndex(
    (option) => option.value === selectedValue?.value
  );

  return (
    <List
      height={Math.min(maxHeight, children.length * height)}
      itemCount={children.length}
      itemSize={height}
      initialScrollOffset={Math.max(0, initialIndex * height)}
    >
      {({ index, style }) => <div style={style}>{children[index]}</div>}
    </List>
  );
};
